/* ARIELLE v34 – Manual gallery arrows on touch and keyboard; no autoplay. */
(function(){
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-ar34-slide]');
    if(!button)return;
    event.preventDefault();
    event.stopPropagation();
    var visual=button.closest('[data-ar34-visual]');
    if(!visual)return;
    var count=visual.querySelectorAll('.ar34-visual__img').length;
    if(count<2)return;
    var current=Number(visual.getAttribute('data-ar34-active')||'0');
    var step=Number(button.getAttribute('data-ar34-slide')||'1');
    var next=(current+step+count)%count;
    visual.setAttribute('data-ar34-active',String(next));
    var indicator=visual.querySelector('[data-ar34-count]');
    if(indicator)indicator.textContent=(next+1)+' / '+count;
  });
})();
